export const onGetSchoolSchemesOfWorkSuccess = (data, get) => {
  if (data.schemesOfWork) {
    get().setSchemesOfWork(data.schemesOfWork, data.schemesOfWorkType);
    get().setTermInfo(data.termInfo);
  }
};

export const onGetSchemeOfWorkSuccess = (data, get) => {
  if (data.schemeOfWork) {
    get().updateSchemeOfWork(data.schemeOfWork);
  }
};

export const onUpdateSchemeOfWorkSuccess = (data, get) => {
  if (data.schemeOfWork) {
    get().updateSchemeOfWork(data.schemeOfWork);
  }
};
